import clsx from 'clsx';
import {Button, Form} from 'react-bootstrap';
import LabelRequired from '../../LabelRequired';
import { EXPORT_TYPE } from '../constant';
import React, {useEffect} from "react";
import {localStorageItem} from "../../../utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../../../auth/core/_consts";
import {toBoolean} from "../../../utils/AppFunction";
import { initUsbPlugin } from "../../../signature-services";

type PrintActionProps = {
	onPrint: () => void;
	onExport: (type: string) => void;
	onSave?: () => void;
	hasSignature?: boolean;
  signFile?: any;
  uploadSignedFile?: (file: File | Blob, fileName?: string) => void;
};

const commonClassName = 'border border-gray-300 rounded text-hover-white';

const PrintAction = (props: PrintActionProps) => {
  const {onPrint, onExport, onSave, hasSignature, signFile, uploadSignedFile} = props;
  const configuration = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION);
  const showSignBtn = toBoolean(configuration?.usbSignature) && hasSignature;

  useEffect(() => {
    // Initialize USB plugin based on system configuration (uses Abstract Factory)
    // Wrap in try-catch to prevent unhandled errors from blocking UI
    const init = async () => {
      try {
        await initUsbPlugin();
      } catch (error) {
        console.warn('USB plugin initialization skipped:', error);
      }
    };
    init();
  }, []);

	return (
		<div>
			<div className="d-flex mb-4">
				<Button
					variant="outline-primary"
					size="lg"
					className={clsx(commonClassName, 'w-100 h-100px')}
					onClick={onPrint}
				>
					<i className="bi bi-printer fs-lg-2hx"></i>
					<span>In</span>
				</Button>
			</div>

			{hasSignature && (
				<div className="mt-8">
					<LabelRequired label="Lưu File" />
					<div className="d-flex gap-1">
						<Button
							size="lg"
							variant="outline-primary"
							className={clsx(commonClassName, 'w-100')}
							onClick={onSave || (() => onExport(EXPORT_TYPE.PDF))}
						>
							<i className="bi bi-download me-1"></i>
							Lưu file PDF
						</Button>
					</div>
				</div>
			)}

			<div className="mt-8">
				<LabelRequired label="Xuất File" />
				<div className="d-flex justify-content-between">
					<Button
						variant="outline-primary"
						size="lg"
						className={commonClassName}
						onClick={() => onExport(EXPORT_TYPE.PDF)}
					>
						<i className="bi bi-filetype-pdf fs-1"></i>
						<span>Pdf</span>
					</Button>
					<Button
						variant="outline-primary"
						size="lg"
						className={commonClassName}
						onClick={() => onExport(EXPORT_TYPE.DOC)}
					>
						<i className="bi bi-filetype-doc fs-1"></i>
						<span>Word</span>
					</Button>
				</div>
			</div>
    </div>
  );
};

export default PrintAction;
